import { render, staticRenderFns } from "./onboardAccountDialog.vue?vue&type=template&id=b989ad54&"
import script from "./onboardAccountDialog.vue?vue&type=script&lang=js&"
export * from "./onboardAccountDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports